export const asset = {
  blue_round: "/assets/images/blue_round.svg",
  gear: "/assets/images/gear.svg",
  car_icon: "/assets/images/car_icon.svg",
  mapImg: "/assets/images/mapimg.png",
  loginBg: "/assets/images/bg-login.jpg",
  logo: "/assets/images/igolf-logo.png",
  caricon: "/assets/images/car_icon.svg",
  menuicon: "/assets/images/menu_icon.svg",
  menuicon2: "/assets/images/menu.png",
  searchicon: "/assets/images/search_icon.svg",
  search: "/assets/images/search.svg",
  coursemap: "/assets/images/course map.svg",
  reports: "/assets/images/graff.svg",
  message: "/assets/images/message.svg",
  right_arrow: "/assets/images/right_arrow.svg",
  right_arrow_white: "/assets/images/right_arrow_white.svg",
  admin_privileges: "/assets/images/admin_privileges.svg",
  printers_terms: "/assets/images/printers_terms.svg",
  asset_tracker: "/assets/images/asset_tracker.svg",
  gen_settings: "/assets/images/gen_settings.svg",
  view: "/assets/images/view.svg",
  pencilicon: "/assets/images/Pencil_icon.svg",
    minus:"/assets/images/minus.svg",
    plus:"/assets/images/plus.svg",
    plusIcon:"/assets/images/plus_icon.svg",
    pinIcon:"/assets/images/pinIocn.svg",
    star:"/assets/images/star-new.svg",
    Union:"/assets/images/Union 19.svg",
    alert:"/assets/images/alert.svg",
    path:"/assets/images/cpo-new.svg",
    messageBlue:"/assets/images/message_blue.svg",
    scale:"/assets/images/scale.svg",
    battery:"/assets/images/battery.svg",
    micon:"/assets/images/M.svg",
    wheelchair:"/assets/images/wheelchair.svg",
    bars:"/assets/images/bars.svg",
    // listIcon:"/list.svg",
    listIconL:"/assets/images/list_new2.svg",
    saveIcon:"/assets/images/save_new.svg",
    messageNew:"/assets/images/message_new.svg",
    srchIcon:"/assets/images/srch-icon.svg",
    bigFlag:"/assets/images/bigFlag.svg",
    search1:"/assets/images/search1.svg",
    blue_icon:"/assets/images/blue.svg",
    grey_icon:"/assets/images/grey_icon.svg",
    nodata:"/assets/images/no-data.svg",
    eye:"/assets/images/eye.svg",
    img404:"/assets/images/404.png",
    imgTree:"/assets/images/tree.svg",
    profileModalImg:"/assets/images/profile_modal_img.png",
    warningicon:"/assets/images/Warning_icon.svg",  // warn
    close:"/assets/images/close.svg", // error
    sucessicon:"/assets/images/sucess_icon.svg", // success
    update:"/assets/images/update.svg",   // info
    editIcon:"/assets/images/save_edit.svg",
    googleIcon:"/assets/images/google_icon.svg",
    bingIcon:"/assets/images/bing_icon.svg",
    azureIcon: "/assets/images/azure_map.png",
    elevationIcon:"/assets/images/heat_logo2.svg",
    crossIcon:"/assets/images/cross.svg",
    rectDrawIcon:"/assets/images/selec_rectangle.svg",
    moveIcon:"/assets/images/move-map.svg",
    imageOverlay:"/assets/images/image_overlay.svg",
    deleteSelection:"/assets/images/delete_selection.svg",
    tools:"/assets/images/tools.svg",
    infoIcon:"/assets/images/info-circle.svg",
    scorecardIcon:"/assets/images/score.png",
    editIcon: "/assets/images/edit.svg",
    whiteScorecardIcon: "/assets/images/white_scorecard.png",
    noteIcon: "/assets/images/note.png",
    //-----------------custom map marker image----------------
    bigTree:"/assets/images/map_tree_big.svg",
    bigRock:"/assets/images/big-rock.svg",
    bigRockBrown:"/assets/images/big-rock-brown.svg",

    cluhouseIcon:"/assets/images/clubhouse_home.svg",
    PageCanNotAccess: "/assets/images/NoAccess.png",
    copyIcon: "/assets/images/copy.png",
    translateIcon: "/assets/images/translate.png",
    // --------------animation-----------
    PageNotFound:"/assets/animation/PageNotFound.gif",
    NoData: "/assets/animation/noData.gif",
    NoSearchData: "/assets/animation/noSearchData.gif",
    //---scoredetailsimages-------
     language: "/assets/images/lang.png",
}

export default asset;
